module.exports = __webpack_public_path__ + "img/banner-7.85fe8de0.jpg";